import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import { graduationRequests } from "api/graduationApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  Labeled,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { InternshipSessionField } from "server/components/Fields/InternshipSessionInput";
import RoomField from "server/components/Fields/RoomField";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowScheduleCycleStream = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли на циклично разписание"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Сесиен стаж">
              <InternshipSessionField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Стажантски план">
              <ReferenceField
                source="planId"
                reference={graduationRequests.getInternshipPlansSelect()}
              >
                <TextField
                  source="name"
                  emptyText={false}
                />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Име на циклично разписание">
              <TextField source="name" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Учебни групи">
              <TextField source="studyGroups" />
            </Labeled>
          </Grid>
        </Grid>
        <SectionTitle
          title="Цикли"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <ArrayField
            source="cycles"
            label=""
          >
            <Datagrid
              bulkActionButtons={false}
              sx={[settings.style.detailsDatagrid, { width: "100%" }]}
            >
              <ReferenceField
                label="Дисциплина"
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
              <TextField
                source="fromDate"
                label="Начална дата"
              />
              <TextField
                source="toDate"
                label="Крайна дата"
              />
              <ArrayField
                source="employees"
                label="Служители"
              >
                <Datagrid
                  bulkActionButtons={false}
                  rowClick={false}
                  sx={settings.style.detailsDatagrid}
                >
                  <ReferenceField
                    source="employeeId"
                    reference={employeeRequests.getProfessorsSelect()}
                    label="Служител"
                  >
                    <FunctionField
                      render={rec => {
                        const scientificDegree = rec.scientificDegreeNameBg ?? "";
                        return rec.secondName
                          ? `${scientificDegree} ${rec.firstName} ${rec.secondName} ${rec.lastName}`
                          : `${scientificDegree} ${rec.firstName} ${rec.lastName}`;
                      }}
                    />
                  </ReferenceField>
                  <TextField
                    source="studyGroups"
                    label="Учебни групи"
                  />
                  <RoomField label="Зала" />
                  <ReferenceField
                    source="buildingId"
                    reference={administrationRequests.getBuildingsSelect()}
                    label="Сграда"
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </Datagrid>
              </ArrayField>
            </Datagrid>
          </ArrayField>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowScheduleCycleStream;
